import PropTypes from 'prop-types';

const OrganizationPropType = PropTypes.shape({
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      city: PropTypes.string,
      zip_code: PropTypes.string
    })
  ),
  name: PropTypes.string,
  description: PropTypes.string,
  resource_type: PropTypes.string,
  website: PropTypes.string,
  all_slugs: PropTypes.arrayOf(PropTypes.string)
});

export default OrganizationPropType;
